import React, { ReactNode } from 'react';

import Button, { ButtonProps } from 'components/buttons/Button';
import { Loader } from 'components/Loader/Loader';

import './Modal.scss';

interface ModalProps {
  title?: string;
  isCloseButtonDisabled?: boolean;
  onClose?: () => void;
  isLoading?: boolean;
  children: ReactNode;
  buttons?: ButtonProps[];
  width?: number;
  closeText?: string;
}

const Modal = ({
  title = '',
  onClose,
  isCloseButtonDisabled = false,
  isLoading = false,
  children,
  buttons = [],
  width,
  closeText = 'Close',
}: ModalProps) => {
  return (
    <div className="modal" onClick={onClose}>
      <div
        className="modal__modal"
        style={{ width }}
        onClick={e => e.stopPropagation()}
      >
        <div>
          <div className="modal__title">{title}</div>
          <div className="modal__content">
            {isLoading ? <Loader /> : children}
          </div>
        </div>
        <div className="modal__footer">
          <Button
            title={closeText}
            onClick={onClose}
            disabled={isCloseButtonDisabled}
          />
          {!isLoading && (
            <div className="footer__buttons">
              {buttons &&
                buttons.map(button => {
                  return (
                    <Button
                      key={
                        typeof button.title === 'string'
                          ? button.title
                          : `modal-button-${Math.random()}`
                      }
                      title={button.title}
                      onClick={button.onClick}
                      loading={button.loading}
                      disabled={button.disabled}
                      className={button.className}
                      type={button.type}
                    />
                  );
                })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default Modal;
